module.exports = require('../_components/@alicd/next-icon/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/icon/index.js
// module id = 20
// module chunks = 0